export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Oturum aç",
    "login.form.hint.user": "Giriş",
    "login.form.hint.password": "Parola",
    "login.form.checkbox.remember-me": "Beni hatırla",
    "login.form.button.sign-in": "Oturum aç",
    "login.form.message.invalid-user-credentials": "Giriş bilgisi veya parola hatalı",
    "login.form.message.account-temporarily-locked": "Hesabınız geçici olarak kilitlendi, 5 dakika sonra tekrar kontrol edin",
    "login.form.message.user-required": "Giriş bilgisi girin",
    "login.form.message.password-required": "Parola girin",
    "login.form.button.forgot-password": "Parolanızı mı unuttunuz?",
    "error.mfa-required.title": "2FA'yı ayarlayın",
    "error.mfa-required.message1": "Hesabınızı korumak için iki faktörlü kimlik denetimi (2FA) gereklidir.",
    "error.mfa-required.message2": "Online Dashboard’daki hesap ayarlarınıza yönlendirileceksiniz. 2FA’yı etkinleştirin, kurulum talimatlarını izleyin ve ardından buraya geri dönün.",
    "error.mfa-required.learnMore": "2FA hakkında daha fazla bilgi edinin",
    "error.mfa-required.continue": "Devam et",
    "error.root-admin-login.title": "Hata 403 – Yasaklı",
    "error.root-admin-login.message": "Salt Okunur Yönetici olarak oturum açtınız. Web Recovery konsoluna erişmek için lütfen bu kullanıcı yerine müşteri kiracı kullanıcısı veya yöneticisi olarak oturum açın",
    "error.server-busy.message": "Bu sunucu meşgul, lütfen daha sonra tekrar deneyin.",
    "error.network-connection.title": "Ağ bağlantı hatası",
    "error.network-connection.message": "İnternet bağlantınızı kontrol edin ve tekrar deneyin.",
    "error.internal-server-error.title": "Dahili sunucu hatası",
    "error.internal-server-error.message": "Hatayı gidermek için aşağıdaki hata ayrıntılarını kullanarak destekle iletişime geçin:",
    "error.internal-server-error.copy.button": "Kopyala"
};
